export default __webpack_public_path__ + "static/media/weekly-check-icon.d5cfaf3c.svg";